import {
  Typography,
  Grid,
  TextField,
  InputAdornment,
  Box,
  Link,
} from "@mui/material";
import { Formik, ErrorMessage, FormikProps, Form } from "formik";
import {
  PricingType,
  ProductType,
} from "../../models/features/Integration/DmsSetup";
import { SetupProfile } from "../../models/features/SetupProfile/SetupProfile";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import React from "react";
import { useGetDmsSetupByIdMutation } from "../../redux/reducer/features/Integration/DmsSetupSlice";
import LinkIcon from "@mui/icons-material/Link";
import KeyIcon from "@mui/icons-material/Key";
import { AppState } from "../../redux/reducer/rootReducer";
import { usePriceOptions } from "../../services/utilities/utility";
import PageLoader from "../app/PageLoader";
import GridWithNewPrices from "../Integration/Synchronization/Grids/DefaultPriceSetting";

export const SiteDetails: React.FunctionComponent = () => {
  const priceOptions = usePriceOptions();
  const dispatch = useDispatch<Dispatch<any>>();
  const formRef: React.Ref<FormikProps<SetupProfile>> = React.useRef(null);

  const dmsSetup = useSelector((state: AppState) => state.authReducer.dmsSetup);

  const [setupProfileData, setSetupProfileData] = useState<SetupProfile>(
    {} as SetupProfile
  );
  const [openPriceType, setOpenPriceType] = useState(false);
  const [productType, setProductType] = useState(ProductType.Wholegoods);

  const [dmsSetupMutation, dmsSetupMutationResult] =
    useGetDmsSetupByIdMutation();

  useEffect(() => {
    dmsSetupMutation({}).then((response: any) => {
      if (response && response.data && response.data.status === 0) {
        let data = response?.data.entity;
        setSetupProfileData({
          id: data.id,
          storeUrl: data.storeUrl,
          storeAccessToken: data.storeAccessToken,
          siteName: data.siteName,
          siteDomain: data.siteDomain,
          IsUpdateCustomerAndPaymentOnly: false,
        });
      }
    });
  }, []);

  const handleClose = () => {
    setOpenPriceType(false);
  };
  return (
    <>
      <PageLoader isLoading={dmsSetupMutationResult.isLoading}></PageLoader>

      <Box sx={{ pb: 2, mt: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Site details
        </Typography>
      </Box>

      <Formik
        initialValues={setupProfileData}
        enableReinitialize={true}
        innerRef={formRef}
        onSubmit={(values) => {}}
      >
        {({ values }) => (
          <>
            <Form>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="siteName"
                    name="siteName"
                    label="Site Name"
                    fullWidth
                    variant="standard"
                    value={values.siteName}
                    InputProps={{
                      readOnly: true,
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="siteDomain"
                    name="siteDomain"
                    label="Site Domain"
                    fullWidth
                    value={values.siteDomain}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <LinkIcon sx={{ color: "rgb(56, 55, 110)" }} />
                        </InputAdornment>
                      ),
                    }}
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    id="accessToken"
                    name="accessToken"
                    label="Access Token"
                    fullWidth
                    value={
                      "*************************************************************"
                    }
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <KeyIcon sx={{ color: "rgb(56, 55, 110)" }} />
                        </InputAdornment>
                      ),
                    }}
                    variant="standard"
                  />
                </Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>

      <Box sx={{ pb: 2, mt: 4 }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Pricing configuration
        </Typography>
      </Box>

      <Box>
        {dmsSetup?.productTypes?.some((type) => type === "Wholegoods") && (
          <Grid item xs={12} display="flex" alignItems="center" gap={1}>
            <Typography
              sx={{ fontWeight: "bold", pt: "5px" }}
              variant="subtitle2"
              gutterBottom
            >
              Wholegoods default price level:
            </Typography>
            {priceOptions
              .filter(
                (x: any) =>
                  x.type === PricingType[dmsSetup?.priceType ?? "Price"]
              )
              .map((option) => (
                <Typography fontSize="0.9rem">{option.label}</Typography>
              ))}
            <Link
              sx={{
                cursor: "pointer",
                fontStyle: "italic",
              }}
              onClick={() => {
                setProductType(ProductType.Wholegoods);
                setOpenPriceType(true);
              }}
            >
              Change
            </Link>
          </Grid>
        )}
        {dmsSetup?.productTypes?.some((type) => type === "Parts") && (
          <Grid item xs={12} display="flex" alignItems="center" gap={1}>
            <Typography
              sx={{ fontWeight: "bold", pt: "5px" }}
              variant="subtitle2"
              gutterBottom
            >
              Parts default price level:
            </Typography>
            {priceOptions
              .filter(
                (x: any) =>
                  x.type === PricingType[dmsSetup?.partsPriceType ?? "Price"]
              )
              .map((option) => (
                <Typography fontSize="0.9rem">{option.label}</Typography>
              ))}
            <Link
              sx={{
                cursor: "pointer",
                fontStyle: "italic",
              }}
              onClick={() => {
                setProductType(ProductType.Parts);
                setOpenPriceType(true);
              }}
            >
              Change
            </Link>
          </Grid>
        )}
      </Box>

      {openPriceType ? (
        <GridWithNewPrices
          handleClose={handleClose}
          isOpen={openPriceType}
          productType={productType}
        />
      ) : (
        <></>
      )}
    </>
  );
};
